<template>
  <AdminContractDetailList :contract="contract" :lockedFilters="lockedFilters" />
</template>


<script>
import AdminContractDetailList from './AdminContractDetailList.vue';


export default {
  name: "ViewContractDetails",
  props: {
    containerInitLoading: Boolean, //getting container data for the first time, show skeletonloader
    containerLoading: Boolean, //loading container data update, do so in the background with small indicator
    containerItem: Object, //container data
  },
  components: {
    AdminContractDetailList,
  },

  data() {
    return {};
  },

  mounted() { },

  methods: {},

  computed: {
    lockedFilters() {
      return { ContractIdList: [this.$route.params.contractId] }
    },
    contract: {
      get() {
        return this.containerItem;
      },
      set(value) {
        this.$emit('SetContainerItem', value);
      }
    },

    loading() {
      return this.containerLoading;
    },
  },

  watch: {},
};
</script>


<style lang='scss'></style>